import { useEffect, useState } from 'react';
import api from './api';

/** Load the Role document for the signed-in user's role slug. */
export function useRoleDoc(user) {
    const [roleDoc, setRoleDoc] = useState(null);

    useEffect(() => {
        if (!user?.role) {
            setRoleDoc(null);
            return;
        }
        let cancel = false;
        api.get('/roles')
            .then(r => {
                if (cancel) return;
                const doc = (r.data.items || []).find(x => x.slug === user.role) || null;
                setRoleDoc(doc);
            })
            .catch(() => { if (!cancel) setRoleDoc(null); });
        return () => { cancel = true; };
    }, [user?.role, (user?.permissions || []).join('|')]);

    return roleDoc;
}
